import "./Header.css";
import logo from "../assets/ciallogon.png";
import { FaBars, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { clearAuthStorage } from "../utils/auth";

function Header({ setOpen }) {

    const navigate = useNavigate();

    const handleLogout = () => {
        // Only clears auth-related keys - preserves device preferences
        // like Theme Settings' saved color across logout/login.
        clearAuthStorage();

        // Redirect to login page
        window.location.href = "/";
    };

    return (

        <div className="header">

            <FaBars
                className="header-menu"
                onClick={() => setOpen(true)}
            />

            <div> </div>

            <div className="header-right">
<img
                    src={logo}
                    alt="CIAL"
                    className="sidebar-logo-imgcial"
                />
                <button
                    className="logout-btn"
                    title="My Profile"
                    onClick={() => navigate("/manage-profile")}
                >
                    <FaUserCircle />
                </button>

                <button
                    className="logout-btn"
                    title="Logout"
                    onClick={handleLogout}
                >
                    <FaSignOutAlt />
                    {/* <span>Logout</span> */}
                </button>

            </div>

        </div>

    );

}

export default Header;